<template>
	<v-container class="content" fluid>
		<v-layout row>
			<v-flex grow>
				<h1 class="display-1 px-3">Statistik</h1>
			</v-flex>
		</v-layout>
		<v-progress-linear v-if="dataLoading" color="accent" indeterminate></v-progress-linear>
		<v-tabs v-model="tab">
			<v-tab v-for="report in reports" :key="report.value">
				{{ report.name }}
			</v-tab>
			<v-tab-item v-for="report in reports" :key="report.value">
				<delivery-delay v-if="report.value === 0"></delivery-delay>
				<v-layout row v-else pt-4>
					<v-flex text-center> Statistik nicht vorhanden </v-flex>
				</v-layout>
			</v-tab-item>
		</v-tabs>
	</v-container>
</template>

<script>
import DeliveryDelay from "./deliveryDelay.vue";

export default {
	components: {
		"delivery-delay": DeliveryDelay,
	},
	data() {
		return {
			tab: 0,
			dataLoading: false,
			reports: [
				{
					name: "Lieferverzögerung",
					value: 0,
				},
				// {
				// 	name: "Fehlerrate",
				// 	value: 1,
				// },
			],
		};
	},
	methods: {},
};
</script>

<style></style>
